// 9fbef606107a605d69c0edbcd8029e5d
import PRODUCTDETAIL_CONSTANTS from './ProductDetail.constants';

export const setProductDetails = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_PRODUCT_DETAILS,
    payload,
  };
};

// To be used when we want to update the existing currentProduct with additional values or update any of the existing values
export const setUpdatedProductDetails = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_UPDATED_PRODUCT_DETAILS,
    payload,
  };
};
// To be used when we want to update the existing currentProduct with additional values or update any of the existing values for multipack / vmp scenario
export const setUpdatedProductDetailsMultipackVmpScenario = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_UPDATED_MULTIPACK_VMP_NONVMP,
    payload,
  };
};

export const setMultiPackDetails = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_MULTIPRODUCT_DETAILS,
    payload,
  };
};

export const setDisableSelectedTab = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_DISABLE_SELECTED_TAB,
    payload,
  };
};

export const singlePageLoadAction = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SINGLE_TAB_STORE,
    payload,
  };
};

export const updateMultipackSelection = (payload) => ({
  type: PRODUCTDETAIL_CONSTANTS.MULTIPACK_SELECTION,
  payload,
});

export const setProductDetailsDynamicData = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_PRODUCT_DETAILS_DYNAMIC_DATA,
    payload,
  };
};

// To be used when we want to update the existing currentProductDynamicData with additional values or update any of the existing values
export const setUpdatedProductDetailsDynamicData = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_UPDATED_PRODUCT_DETAILS_DYNAMIC_DATA,
    payload,
  };
};

export const getProductDetails = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.FETCH_PRODUCT_DETAILS,
    payload,
  };
};

export const fetchSimilarProducts = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.FETCH_SIMILAR_PRODUCTS,
    payload,
  };
};

export const setSimilarProducts = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_SIMILAR_PRODUCTS,
    payload,
  };
};

export const resetSimilarProducts = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.RESET_SIMILAR_PRODUCTS,
    payload,
  };
};
export const openSimilarProductsModal = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.OPEN_SIMILAR_PRODUCTS_MODAL,
    payload,
  };
};
export const closeSimilarProductsModal = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.CLOSE_SIMILAR_PRODUCTS_MODAL,
    payload,
  };
};

export const dynamicContentLoader = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.FETCH_DYNAMIC_CONTENT_PROMO,
    payload,
  };
};

export const setAddToFavoritePDP = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_ADD_TO_FAVORITE,
    payload,
  };
};

export const removeAddToFavoritePDP = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.REMOVE_OUTFIT_ITEM_FROM_FAVORITE,
    payload,
  };
};

export const setPageUrl = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_PAGE_URL,
    payload,
  };
};

export const setPDPLoadingState = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_PDP_LOADING_STATE,
    payload,
  };
};

export const loadSocialProofData = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.LOAD_SOCIAL_PROOF_DATA,
    payload,
  };
};

export const clearSocialProofData = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.CLEAR_SOCIAL_PROOF_DATA,
    payload,
  };
};

export const setPDPDisplayPriceState = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_PDP_DISPLAY_PRICE,
    payload,
  };
};

export const resetCountUpdated = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.RESET_COUNT_UPDATED,
    payload,
  };
};

export const setIsPDPCalledFromRecommendation = () => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_PDP_CALLED_VIA_RECOMMENDATION,
  };
};
export const updateSelectedSizeStatus = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SELECTED_SIZE_STATUS,
    payload,
  };
};
export const getReviewData = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.GET_REVIEW_DATA,
    payload,
  };
};
export const setReviewData = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_REVIEW_DATA,
    payload,
  };
};
export const updateDeliveryMethodSelection = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.UPDATE_DELIVERY_METHOD_INDEX,
    payload,
  };
};

export const setIsSidebarMounted = (payload) => ({
  type: PRODUCTDETAIL_CONSTANTS.IS_SIDEBAR_MOUNTED,
  payload,
});

export const setTabSectionName = (payload) => ({
  type: PRODUCTDETAIL_CONSTANTS.SET_TAB_SECTION_NAME,
  payload,
});
export const setPlpProductData = (payload) => ({
  type: PRODUCTDETAIL_CONSTANTS.SET_PLP_PRODUCT_DATA,
  payload,
});

export const setSlpProductData = (payload) => ({
  type: PRODUCTDETAIL_CONSTANTS.SET_SLP_PRODUCT_DATA,
  payload,
});
export const setCartProductData = (payload) => ({
  type: PRODUCTDETAIL_CONSTANTS.SET_CART_PRODUCT_DATA,
  payload,
});

export const setSizeGuideModuleX = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_RETURN_SIZECHART_MODULEX_CONTENT,
    payload,
  };
};

export const fetchSizeGuideModuleX = (payload) => {
  return {
    payload,
    type: PRODUCTDETAIL_CONSTANTS.FETCH_SIZECHART_MODULEX_CONTENT,
  };
};

export const setAdditionalPromoModuleX = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_ADDITIONAL_PROMO_MODULEX_CONTENT,
    payload,
  };
};

export const fetchAdditionalPromoModuleX = (payload) => {
  return {
    payload,
    type: PRODUCTDETAIL_CONSTANTS.FETCH_ADDITIONAL_PROMO_MODULEX_CONTENT,
  };
};

export const fetchShippingAndReturnsModuleX = (payload) => {
  return {
    payload,
    type: PRODUCTDETAIL_CONSTANTS.FETCH_SHIPPING_AND_RETURNS_MODULEX_CONTENT,
  };
};

export const setShippingAndReturnsModuleX = (payload) => {
  return {
    payload,
    type: PRODUCTDETAIL_CONSTANTS.SET_SHIPPING_AND_RETURNS_MODULEX_CONTENT,
  };
};

export const setSyteScriptLoaded = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_SYTE_SCRIPT_LOADED,
    payload,
  };
};

export const setAlternateStyles = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_ALTERNATE_STYLES,
    payload,
  };
};

export const scrollToIndex = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.SET_INDEX,
    payload,
  };
};

export const setIsDeptClicked = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.IS_DEPT_CLICKED,
    payload,
  };
};

export const isStickyATBLoaded = (payload) => {
  return {
    type: PRODUCTDETAIL_CONSTANTS.IS_STICKY_ATB_LOADED,
    payload,
  };
};
